class WishlistToast extends HTMLElement {
  connectedCallback() {
    this._messageEl = this.querySelector('[data-message]');
    this._closeBtn = this.querySelector('.cart-error-toast__close');
    this._defaultDuration = Number.parseInt(this.dataset.duration, 10) || 2000;

    this._closeBtn?.addEventListener('click', () => this.hide());

    this._onToastEvent = (event) => {
      const detail = event.detail || {};
      const duration =
        typeof detail.duration === 'number' && detail.duration > 0
          ? detail.duration
          : this._defaultDuration;

      const message = this._resolveMessage(detail);
      if (!message) return;

      this._setActionState(detail.action);
      this.show(message, duration);
    };

    this._onWishlistStateChange = (event) => {
      const detail = event.detail || {};
      if (detail.optimistic !== true) return;

      const action = detail.inWishlist === true ? 'added' : 'removed';
      const key = `${detail.productHandle || 'unknown'}:${action}`;
      const now = Date.now();

      // Avoid duplicate toasts when multiple listeners emit nearly together.
      if (this._lastToastKey === key && now - (this._lastToastAt || 0) < 500) return;
      this._lastToastKey = key;
      this._lastToastAt = now;

      const message =
        action === 'added' ? this.dataset.addedMessage : this.dataset.removedMessage;
      if (!message) return;

      this._setActionState(action);
      this.show(message, this._defaultDuration);
    };

    document.addEventListener('armada:wishlist:toast', this._onToastEvent);
    document.addEventListener('armada:wishlist-state-change', this._onWishlistStateChange);
  }

  disconnectedCallback() {
    document.removeEventListener('armada:wishlist:toast', this._onToastEvent);
    document.removeEventListener('armada:wishlist-state-change', this._onWishlistStateChange);
    clearTimeout(this._timer);
  }

  _resolveMessage(detail) {
    if (typeof detail.message === 'string' && detail.message.trim()) {
      return detail.message.trim();
    }

    if (detail.action === 'added') return this.dataset.addedMessage;
    if (detail.action === 'removed') return this.dataset.removedMessage;

    return '';
  }

  _setActionState(action) {
    const isAdded = action === 'added';
    this.classList.toggle('is-added', isAdded);
    this.classList.toggle('is-removed', !isAdded);
  }

  show(message, durationMs) {
    if (!this._messageEl) return;

    this._messageEl.textContent = message;
    this.removeAttribute('hidden');
    this.offsetHeight; // eslint-disable-line no-unused-expressions
    this.classList.add('is-visible');

    clearTimeout(this._timer);
    this._timer = setTimeout(() => this.hide(), durationMs);
  }

  hide() {
    this.classList.remove('is-visible');
    clearTimeout(this._timer);

    this.addEventListener(
      'transitionend',
      () => this.setAttribute('hidden', ''),
      { once: true }
    );
  }
}

if (!customElements.get('wishlist-toast')) {
  customElements.define('wishlist-toast', WishlistToast);
}
